// extracted by mini-css-extract-plugin
var _1 = "body__tM3yG";
var _2 = "card__bM_Iv";
export { _1 as "body", _2 as "card" }
